

































































import { Vue, Component, Prop, Ref, Mixins } from "vue-property-decorator";
import PoiCollapsibleList from "@/components/ScoutingPlace/CollapsibleList.vue";
import AreaCollapsibleList from "@/components/ScoutingArea/CollapsibleList.vue";
import { currentScoutingStore, currentUserStore } from "@/store/typed";
import ConfirmModal from "../../components/ConfirmModal.vue";
import ScoutingAreaMixin from "@/mixins/http/ScoutingAreaMixin";
import CreateAnalysisModal from "@/components/Scouting/CreateAnalysisModal.vue";
import { UserRoles } from "@/models/User";

@Component({
  components: {
    PoiCollapsibleList,
    ConfirmModal,
    AreaCollapsibleList,
    CreateAnalysisModal,
  },
})
export default class Poi extends Mixins(ScoutingAreaMixin) {
  @Ref() readonly confirm!: ConfirmModal;
  @Ref() readonly createAnalysisModal!: CreateAnalysisModal;
  @Ref() readonly poiList!: PoiCollapsibleList;

  poiListOpen = true;
  areaListOpen = false;

  mounted() {
    if (!this.disabledPoiList && !this.disabledAreaList) {
      this.poiListOpen = true;
      this.areaListOpen = false;
    } else {
      if (this.disabledPoiList) {
        this.poiListOpen = false;
        this.areaListOpen = true;
      } else {
        this.poiListOpen = true;
        this.areaListOpen = false;
      }
    }
  }

  async reset() {
    const confirmed = await this.confirm.confirm(
      "Sei sicuro di voler iniziare una nuova ricerca? Tutti i dati non salvati verranno persi."
    );
    if (confirmed) {
      await currentScoutingStore.resetScouting();
      currentScoutingStore.centerOnAllObjects();
      this.$router.replace({ name: "scouting-poi" });
    }
  }

  get displayAnalysisButton() {
    return currentUserStore.user?.isOneOf([
      UserRoles.ANALYST,
      UserRoles.ADMINISTRATOR,
      UserRoles.SUPERADMIN,
      UserRoles.SYSTEM_ADMIN,
    ]);
  }

  get scoutingPlaces() {
    return currentScoutingStore.scoutingPlaces;
  }

  get scoutingAreas() {
    return currentScoutingStore.scoutingAreas;
  }

  get poiCount() {
    return this.scoutingPlaces?.length || 0;
  }

  get areaCount() {
    return this.scoutingAreas?.length || 0;
  }

  get disabledPoiList() {
    return this.areaCount !== 0;
  }

  get disabledAreaList() {
    return this.poiCount !== 0;
  }

  get canCreateAnalysis() {
    return this.poiCount > 0 || this.areaCount > 0;
  }

  async nextStep() {
    const scouting = currentScoutingStore.scouting;
    if (scouting) {
      await currentScoutingStore.saveScouting(scouting);
    }
  }

  onPoiListStatusChanged(closed: boolean) {
    if (!this.disabledAreaList) {
      this.poiListOpen = !closed;
      this.areaListOpen = closed;
    }
  }

  onAreaListStatusChanged(closed: boolean) {
    if (!this.disabledPoiList) {
      this.areaListOpen = !closed;
      this.poiListOpen = closed;
    }
  }

  get canCloseAccordion() {
    return !this.disabledPoiList && !this.disabledAreaList;
  }

  onCreateAnalysis() {
    //if(!this.canCreateAnalysis)
    //  return;
    this.createAnalysisModal.show();
  }
}
